import { TagListProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: TagListProps = {
  tags: [
    {
      id: '1',
      children: 'Some Tag',
    },
  ],
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as TagListProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
